// extracted by mini-css-extract-plugin
export default {"jobs":"SavedJobs_jobs__6c0fx","item":"SavedJobs_item__dvhOe"};